import React from "react";
import "./BookingHeader.scss";
import { BsChevronLeft } from "react-icons/bs";
import { CgClose } from "react-icons/cg";
import { useSelector } from "react-redux";

const BookingHeader = (props) => {
  const widgetInfo = useSelector((state) => state.widget.widget);

  return (
    <div
      className={
        "BookingHeader" +
        (props.termsOpen || props.notesOpen ? " terms" : "") +
        (props.reviews ? " reviews" : "") +
        (props.steps === 5 && props.step === 1
          ? " anime"
          : props.step === 2
          ? " anime"
          : "")
      }
      style={{
        backgroundImage: `${
          widgetInfo.company.widget_settings.background_color
            ? widgetInfo.company.widget_settings.background_color
            : "linear-gradient(117.58deg, #1A73E8 0%, #1A56A6 100%)"
        }`,
      }}
    >
      <div className="stepInfo">
        <div className="left">
          <div className="back" onClick={props.onBack}>
            <BsChevronLeft />
          </div>
          <p>
            Steg {props.steps === 5 ? props.step : props.step - 1} av{" "}
            {props.steps}
          </p>
        </div>
        {props.step === 1 && <h4>Välj plats</h4>}
        {props.step === 2 && <h4>Välj tjänst</h4>}
        {props.step === 3 && <h4>Välj utförare</h4>}
        {props.step === 4 && <h4>Välj tid</h4>}
        {props.step === 5 &&
          !props.notesOpen &&
          (props.termsOpen ? <h4>Villkoren</h4> : <h4>Slutför bokning</h4>)}
        {props.notesOpen && <h4>Lägg till notering</h4>}
        {props.reviews && <h4>Recensioner & Betyg</h4>}
        <div className="close" onClick={props.onClose}>
          <CgClose />
        </div>
      </div>
      {props.step === 1 && <h2>Välj plats</h2>}
      {props.step === 2 && <h2>Välj tjänst</h2>}
      {props.step === 3 && <h2>Välj utförare</h2>}
      {props.step === 4 && <h2>Välj tid</h2>}
      {props.step === 5 &&
        !props.notesOpen &&
        (props.termsOpen ? (
          <h2>Terms and conditions</h2>
        ) : (
          <h2>Slutför bokning</h2>
        ))}
    </div>
  );
};

export default BookingHeader;
